export default __webpack_public_path__ + "static/media/porcelain-pavers-composite.0c69d4a1.jpg";